import { NavLink, useLocation } from 'react-router';
import { Button } from '@/components/ui/button';
import PageRoutes from '@/lib/routing/PageRoutes';

const menuItems = Object.values(PageRoutes);

export const Navigation = () => {
  const { pathname } = useLocation();

  return (
    <div className="flex w-full justify-center gap-3 overflow-auto pt-1">
      {menuItems.map((page) => {
        if (!page.showInNav) {
          return null;
        }

        return (
          <Button
            asChild
            variant={
              page.path != '/' && pathname.includes(page.path)
                ? 'secondary'
                : 'default'
            }
            key={page.path}
          >
            <NavLink to={page.path}>{page.name}</NavLink>
          </Button>
        );
      })}
    </div>
  );
};
